// /var/www/afra/web-design.rampagesoft.com/my-app/src/component/ExamplesSlider.js
// src/component/ExamplesSlider.js
import React, { useMemo } from 'react';
import '../css/ExamplesSlider.scss';
import homeBusinessData from '../data/HomeBusiness.json';

const FALLBACK_IMG = '/media/Examples/f80302.webp';

const ExamplesSlider = ({ Swiper, SwiperSlide, swiperConfig, sectionId }) => {
  // เลือก section
  const section =
    homeBusinessData.find((sec) => sec.id === sectionId) ||
    homeBusinessData[0] ||
    { examples: [] };

  // ปรับ src ให้ถูกต้องทั้ง external & relative
  const buildImgSrc = (src = '') => {
    const trimmed = src.trim();
    if (/^https?:\/\//i.test(trimmed)) {
      return trimmed;               // URL เต็ม → ใช้ตรง ๆ
    }
    // path ภายใน (เช่น '/media/...') → ต่อด้วย PUBLIC_URL
    return `${process.env.PUBLIC_URL}${trimmed.startsWith('/') ? '' : '/'}${trimmed}`;
  };

  // เตรียม list images
  const examples = useMemo(() => {
    const list =
      Array.isArray(section.examples) && section.examples.length
        ? section.examples
        : [{ id: 'fallback', src: FALLBACK_IMG, alt: 'ตัวอย่างสำรอง' }];

    // ลบซ้ำ, trim & map
    const seen = new Set();
    return list
      .map((item) => ({
        ...item,
        src: item.src ? item.src.trim() : FALLBACK_IMG,
      }))
      .filter((item) => !seen.has(item.src) && seen.add(item.src));
  }, [section.examples]);

  // Guard
  if (!Swiper || !SwiperSlide) {
    console.error('Swiper หรือ SwiperSlide ไม่ได้ถูกส่งมา');
    return <div className="examples-slider--error">ไม่สามารถโหลด Slider ได้</div>;
  }

  return (
    <div className="examples-slider">
      <Swiper {...swiperConfig}>
        {examples.map((example) => (
          <SwiperSlide key={example.id}>
            <img
              src={buildImgSrc(example.src)}
              alt={example.alt}
              className="example-image"
              style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
              loading="lazy"
              onError={(e) => {
                console.error(`Failed to load image: ${example.src}`);
                e.currentTarget.src = buildImgSrc(FALLBACK_IMG);
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ExamplesSlider;
